import styled, { css } from "styled-components";
import TextareaAutosize from "react-textarea-autosize";

export const Title = styled.h2`
  color: var(--primary-blue-900);
  font-family: Rubik;
  font-size: 1.286rem; // 18px
  line-height: normal;
  font-style: normal;
  font-weight: 600;
  margin: 0 0 46px;
  width: fit-content;

  ${({ $hasPermission }) =>
    $hasPermission &&
    css`
      cursor: pointer;
    `}
`;

export const MetaInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  margin-bottom: 32px;
`;

export const MetaInfoItem = styled.div`
  border-right: 1px solid var(--primary-dark-200);
  display: flex;
  flex: 1;
  padding-right: 30px;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  align-self: stretch;

  &:last-child {
    padding-right: 0;
    border-right: none;
  }

  p:first-child {
    align-self: stretch;
    color: var(--primary-dark-300);
    font-family: Rubik;
    font-size: var(--fs-sm);
    line-height: normal;
    font-style: normal;
    font-weight: 400;
  }

  p:last-child {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    align-self: stretch;

    overflow: hidden;
    color: var(--primary-dark);
    text-overflow: ellipsis;
    font-family: Rubik;
    font-size: var(--fs-base);
    line-height: normal;
    font-style: normal;
    font-weight: 500;
  }
`;

export const FloatingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 250px;
  padding: 10px 20px;
  border-radius: 4px;
  background-color: var(--primary-white);
  border: 1px solid var(--primary-dark);

  width: ${({ width }) => width};

  ${MetaInfoItem} {
    border: none;
    padding-right: 0;
    min-height: auto;
  }
`;

export const editStyles = css`
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding-bottom: 46px;

  position: relative;

  ${({ $isEmpty }) =>
    $isEmpty &&
    css`
      color: var(--primary-grey);
      font-style: italic;
    `}

  > button[id="edit-filter-button"] {
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &:hover {
    > button[id="edit-filter-button"] {
      opacity: 1;
    }
  }
`;

export const TextDesc = styled.div`
  color: var(--primary-dark);
  font-style: normal;
  transition: all 0.2s ease;
  margin-top: 8px;

  font-size: 1rem;
  line-height: 20px;
  color: var(--primary-dark);
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;

  ${({ $isEmpty }) =>
    $isEmpty &&
    css`
      color: var(--primary-dark-300);
      font-weight: 400;
    `}
`;

export const DescriptionTextarea = styled(TextareaAutosize)`
  font-size: 1rem;
  line-height: 20px;
  font-family: Rubik;
  border: 1px solid var(--primary-grey-200);
  border-radius: 8px;

  background-color: var(--primary-white);
  color: var(--primary-dark);
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;

  width: 100%;
  padding: 12px;
  margin-top: 8px;
  margin-bottom: 12px;
  resize: none;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: var(--primary-blue);
  }
`;
